import { apiClient } from "../lib/api";

export const documentApi = {
  listByEmployee: (employeeId) => apiClient.get(`/documents/by-employee/${employeeId}`),
  upload: (employeeId, category, file) => {
    const form = new FormData();
    form.append("employee_id", employeeId);
    form.append("category", category);
    form.append("file", file);
    return apiClient.post("/documents/upload", form, { headers: { "Content-Type": "multipart/form-data" } });
  },
  download: (documentId) => apiClient.get(`/documents/${documentId}/download`, { responseType: "blob" }),
  review: (documentId, payload) => apiClient.post(`/documents/${documentId}/review`, payload),
  queue: (params) => apiClient.get("/documents/queue", { params }),
  assign: (documentId, reviewerId) => apiClient.post(`/documents/${documentId}/assign`, null, { params: { reviewer_id: reviewerId } }),
  bulkAssign: (documentIds, reviewerId) => apiClient.post("/documents/bulk-assign", { document_ids: documentIds, reviewer_id: reviewerId }),
};
